<form [formGroup]="customerContactForm" autocomplete="on">
  <div [ngClass]="class">
    <div [ngClass]="class + '__header'">
      <h4>Kontakdaten Kunden</h4>
    </div>

    <div class="grid" [ngClass]="class + '__customer-info'">
      <!-- Salutation -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label class="required" for="salutation">Anrede</label>
          <p-dropdown [options]="salutationSelect" formControlName="salutation" placeholder="Anrede auswählen.."></p-dropdown>
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('salutation')?.invalid && customerContactForm.get('salutation')?.touched"
          >
            {{ getErrorMessage('salutation', 'Anrede') }}
          </span>
        </div>
      </div>

      <!-- First Name -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="firstName" class="required">Vorname</label>
          <input id="firstName" pInputText formControlName="firstName" />
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('firstName')?.invalid && customerContactForm.get('firstName')?.touched"
          >
            {{ getErrorMessage('firstName', 'Vorname') }}
          </span>
        </div>
      </div>

      <!-- Last Name -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="lastName" class="required">Nachname</label>
          <input id="lastName" pInputText formControlName="lastName" />
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('lastName')?.invalid && customerContactForm.get('lastName')?.touched"
          >
            {{ getErrorMessage('lastName', 'Name') }}
          </span>
        </div>
      </div>

      <!-- Comapany Name -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="company" class="required">Firmenname</label>
          <input id="company" pInputText formControlName="company" />
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('company')?.invalid && customerContactForm.get('company')?.touched"
          >
            {{ getErrorMessage('company', 'Name') }}
          </span>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="email" class="required">E-Mail Kunde</label>
          <input id="email" type="email" pInputText formControlName="email" />
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('email')?.invalid && customerContactForm.get('email')?.touched"
          >
            {{ getErrorMessage('email', 'E-Mail-Adresse') }}
          </span>
        </div>
      </div>
    </div>
    <div [ngClass]="class + '__header'">
      <h4>Vertriebsinformationen</h4>
    </div>

    <div class="grid">
      <!-- salesPartner -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="salesPartner" class="required">Vertriebspartner</label>
          <p-dropdown
            [options]="salesPartnerSelect"
            [(ngModel)]="selectedSalesPartner"
            formControlName="salesPartner"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            [emptyFilterMessage]="'Keine Ergebnisse gefunden'"
          ></p-dropdown>
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('salesPartner')?.invalid && customerContactForm.get('salesPartner')?.touched"
          >
            {{ getErrorMessage('salesPartner', 'Fachhandelspartner') }}
          </span>
        </div>
      </div>

      <!--Sales Partner Email -->
      <div class="col-12">
        <div [ngClass]="class + '__field'">
          <label for="salesPartnerEmail" class="required">E-Mail Vertriebspartner</label>
          <input id="salesPartnerEmail" type="email" pInputText formControlName="salesPartnerEmail" />
          <span
            class="small-text text-highlight"
            *ngIf="customerContactForm.get('salesPartnerEmail')?.invalid && customerContactForm.get('salesPartnerEmail')?.touched"
          >
            {{ getErrorMessage('salesPartnerEmail', 'E-Mail-Adresse') }}
          </span>
        </div>
      </div>

      <div class="col-12">
        <p-button
          [label]="'Angebot senden'"
          [icon]="'pi pi-arrow-right'"
          iconPos="right"
          [class]="'p-text-normal'"
          [disabled]="false"
          (onClick)="sendOffer()"
          [loading]="isSendingOffer"
        ></p-button>
      </div>
      <p *ngIf="sendOfferResult" class="small-text ml-2 text-highlight">
        {{ sendOfferResult }}
      </p>
    </div>
  </div>
</form>

<form autocomplete="on" style="visibility: hidden; height: 0; overflow: hidden"></form>
